
import React, { useMemo } from 'react'
import { useComment } from '../../../../../../utils/reactQuery/cards';
import Loader from '../../../../../../components/Loader';
import { useHistory, useWorklog } from '../../../../../../utils/reactQuery/worklog';
import AllDetailList from './AllDetailList';

const AllDetail = ({ cardId, boardPermission }) => {
  const {
    isLoading: isCommentLoading,
    comment,
  } = useComment(cardId);
  const { isLoading: isHistoryLoading, history } = useHistory(cardId);
  const {
    isLoading: isWorklogLoading,
    worklog,
  } = useWorklog(cardId);

  const comments = useMemo(() => (
    comment?.data.data.responseData.map((el) => ({
      ...el,
      objType: "comment",
      consolidateTime: el.comment_time,
    })) || []
  ), [comment]);

  const historys = useMemo(() => (
    history?.data.data.responseData.map((el) => ({
      ...el,
      objType: "history",
      consolidateTime: el.at_time,
    })) || []
  ), [history]);

  const worklogs = useMemo(() => (
    worklog?.data.data.responseData.map((el) => ({
      ...el,
      objType: "worklog",
      consolidateTime: el.worklog_time,
    })) || []
  ), [worklog]);



  return (
    <>
      {isCommentLoading || isHistoryLoading || isWorklogLoading ? (
        <div className="loader-center">
          <Loader color={"black"} />
        </div>
      ) : (
        <AllDetailList
          cardId={cardId}
          comments={comments}
          historys={historys}
          worklogs={worklogs}
          boardPermission={boardPermission}
        />
      )}
    </>
  );
};

export default React.memo(AllDetail)